/* ===================================================================
   es-header.js  v1  (2026-10-17)
   作用：桌面端把「国旗/En 语言切换器」与「搜索图标」在 DOM 层真正互换
   - 搜索图标（header 顶层 details-modal.header__search）→ 移入 .header__icons 开头
   - 国旗/En（.header__icons 里的两个 localization-form）→ 包进 .es-loc-wrap，
     放到 header 顶层原搜索图标的 grid 位置（grid-area:left-icons，由 es-header.css 安置）
   幂等：可重复执行，只换一次；主题 JS 重排后 load 时再校验一次
   摘掉本文件 + es-header.css = 完全回滚
   =================================================================== */
(function () {
  function swap() {
    var header = document.querySelector('header.header');
    if (!header) return;

    // 仅桌面端执行（<990px 是移动抽屉布局，绝不能动）
    if (window.innerWidth < 990) return;

    // 幂等：已处理过就跳过
    if (header.dataset.esHeaderSwapped === '1') return;

    var icons = header.querySelector('.header__icons');
    if (!icons) return;

    // 外层搜索图标：header 的直接子元素
    var outerSearch = header.querySelector(':scope > details-modal.header__search');
    // 图标组里的两个语言/国家切换器（顺序：国旗在前、En 在后）
    var locs = icons.querySelectorAll(':scope > localization-form');
    // 组内原生的隐藏搜索副本（不动它，保持主题原样）
    var innerSearch = icons.querySelector(':scope > details-modal.header__search');

    // 结构不齐就不动手（防止主题改版误伤）
    if (!outerSearch || locs.length < 2) return;

    var flag = locs[0]; // localization-form-v2--images-circle（国旗/国家）
    var lang = locs[1]; // localization-form-v2（En 语言）

    // 1) 包一层容器，放到 header 顶层（插在 logo 前 → left-icons 格）
    var wrap = document.createElement('div');
    wrap.className = 'es-loc-wrap';
    wrap.appendChild(flag);
    wrap.appendChild(lang);
    header.insertBefore(wrap, header.querySelector('h1.header__heading'));

    // 2) 搜索图标移入图标组，排最前（原生隐藏副本仍在它后面，保持隐藏）
    icons.insertBefore(outerSearch, icons.firstChild);

    header.dataset.esHeaderSwapped = '1';
  }

  // 立即尝试（脚本紧跟 header 之后同步加载时，此处即可完成交换 → 零闪烁）
  swap();

  // 兜底 1：脚本若放在 <head>（header 尚未解析），用 MutationObserver 一旦 header
  //         出现就立刻换（微任务级别，早于首屏绘制）
  if (!document.querySelector('header.header')) {
    var mo = new MutationObserver(function () {
      if (document.querySelector('header.header')) {
        swap();
        if (document.querySelector('header.header').dataset.esHeaderSwapped === '1') mo.disconnect();
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    // 安全阀：8 秒后无论如何停止观察
    setTimeout(function () { mo.disconnect(); }, 8000);
  }

  // 兜底 2：DOM 就绪后再试一次（幂等）
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swap);
  }
  // 兜底 3：防主题 JS 异步重排，load 后再校验（幂等）
  window.addEventListener('load', swap);
  // 桌面/移动切换：若初始在移动端加载（未交换），切到桌面时补一次交换
  var lastDesktop = window.innerWidth >= 990;
  window.addEventListener('resize', function () {
    var isDesktop = window.innerWidth >= 990;
    if (isDesktop && !lastDesktop) swap();
    lastDesktop = isDesktop;
  });
})();
